import React, { useEffect } from 'react'
import Header from './Header'
import { connect } from 'react-redux'
import { getFinalCart, converDate } from '../redux/actions/cart';
import { allOrdersTotalSelector, allOrdersCount, orderStatus } from '../redux/reducers/cart';
import Order from './Order';
import Footer from './Footer';
import socketIOClient from "socket.io-client";
const ENDPOINT = "https://www.werafoods.com:9005";

function CurrentOrders({ getFinalCart, orders, totalAll, orderCount, state, error }) {

    useEffect(() => {
        getFinalCart();
    }, [])

    useEffect(() => {
        const orderIds = orders.map(order => order.order_id.toString());
        if (orderIds.length > 0) {
            const socket = socketIOClient(ENDPOINT);
            socket.on("notification", data => {
                if (orderIds.includes(data.message))
                    getFinalCart();
            });

            return () => {
                socket.disconnect();
            }
        }

    }, [orders])


    return (
        <>
            <Header />
            <div className="current-orders-main">
                <div className="current-order-list mt-55">
                    {orders && orders.map((order, index) => <Order key={order.order_id} order={order} index={index} />)}
                </div>
                {error && <div className="alert alert-danger">
                    {error}
                </div>}
            </div>
            <Footer totalAll={totalAll} />
        </>
    )
}

const mapStateToProps = (state) => ({
    orders: state.cart.finalCartResponse?.orders,
    totalAll: allOrdersTotalSelector(state),
    orderCount: allOrdersCount(state),
    error: state.cart.finalCartError,
})

export default connect(mapStateToProps, { getFinalCart })(CurrentOrders);
